import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Syne\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-syne\",\"display\":\"swap\",\"weight\":[\"500\",\"600\",\"700\",\"800\"]}],\"variableName\":\"syne\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Sora\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sora\",\"display\":\"swap\",\"weight\":[\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"sora\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/common/StickyHeaderNav.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/styles/index.css");
